import Vue from 'vue';
import Vuex from 'vuex';

import users from '@/storages/users';
import inBound from '@/storages/in_bound';
import analyzer from '@/storages/analyzer';
import readyForUtilize from '@/storages/ready_for_utilize';
import inStock from '@/storages/in_stock';
import shops from '@/storages/shops';
import utilized from '@/storages/utilized';
import notifications from '@/storages/notifications';
import shipments from '@/storages/shipments';
import boxes from '@/storages/boxes';
import files from '@/storages/files';

Vue.use(Vuex);

const vuex = new Vuex.Store({
  state: {
    app_section: '',
  },
  mutations: {
    set_app_section: (state, payload) => {
      state.app_section = payload;
    },
  },
  getters: {
    get_app_section(state) {
      return state.app_section;
    },
    is_storage(state) {
      return state.app_section === 'storage';
    },
  },
  actions: {},
  modules: {
    users,
    inBound,
    analyzer,
    inStock,
    readyForUtilize,
    shops,
    utilized,
    notifications,
    shipments,
    boxes,
    files,
  },
});
export default vuex;
